const PERMISSION_KEY= "core:orders";
const PAGE_URL = {
    ORDER_PAGE: "/admin/core/order"
}

export {PERMISSION_KEY, PAGE_URL}

